/**
 * function called on Page load to invoke actions on initialize
 */
const handleAppInit = (): void => {
    // eslint-disable-next-line no-console
    console.log('AppInit')
}

export default handleAppInit
